export default __webpack_public_path__ + "static/media/select.60adc4df.svg";